<template>
    <layout>
        <div class="row">
            <div class="col-sm-12">
                <form autocomplete="off" method="post" data-vv-scope="form" @submit.prevent="onBeforeSaveItem(fallback)">
                    <div class="row mb-3">
                        <div class="col-sm-auto">
                            <h1 class="content-title">{{ titleConfigItem }}</h1>
                        </div>
                    </div>
                    <template v-if="optionsNotification">
                        <div class="mb-3" v-for="(option, idx) in optionsNotification" :key="`option-${idx}`">
                            <h6 class="font-weight-normal">
                                {{ option.name }}
                            </h6>
                            <hr class="mt-2" />
                            <div class="row">
                                <div class="col">
                                    <template v-for="(item) in option.events">
                                        <div class="form-group" :key="`option-item-${item.id}`">
                                            <div class="form-check city-form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    :disabled="readonlyFormItem"
                                                    v-model="form.events"
                                                    :value="item.id"
                                                    :id="`cb-item-${item.id}`"
                                                    :name="`cb-item-${item.id}`"
                                                    v-validate="''">
                                                <label class="form-check-label h-auto" :for="`cb-item-${item.id}`">
                                                    <div class="d-flex flex-column align-items-start">
                                                        <strong>{{ item.name }}</strong>
                                                        <small v-if="item.help">{{ item.help }}</small>
                                                    </div>
                                                </label>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </template>

                    <div>
                        <h6 class="font-weight-normal">
                            {{ $t(`${pageID}.config.admin.custom_admin_email.recipients.title`) }}
                        </h6>
                        <hr class="mt-2" />
                        <p>{{ $t(`${pageID}.config.admin.custom_admin_email.recipients.description`) }}</p>
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <MaterialInput
                                        :readonly="readonlyFormItem"
                                        :disabled="readonlyFormItem"
                                        class="city-form-group city-bg"
                                        id="input-custom_admin_email_recipients"
                                        name="custom_admin_email_recipients"
                                        v-model.trim="form.custom_admin_email_recipients"
                                        v-validate="'emails'"
                                        :inputClasses="[{'is-invalid': fnHasError('custom_admin_email_recipients')}]"
                                        :error="fnFirstError('custom_admin_email_recipients')"
                                        :helpText="`${pageID}.config.admin.custom_admin_email.recipients.help`">
                                        {{ $t(`${pageID}.config.admin.custom_admin_email.recipients.label`) }}
                                    </MaterialInput>
                                </div>
                            </div>
                        </div>
                    </div>

                    <buttons-footer
                        :enableButtons="!readonlyFormItem"
                        :cancelTitle="cancelTitle"
                        :submitTitle="submitTitle"
                        :isDisabled="isDisabled"
                        :showCancelButton="!!fallback"
                        @save="onBeforeSaveItem(fallback)"
                        @cancel="handleBack(fallback, true)">
                    </buttons-footer>
                </form>
            </div>
        </div>
    </layout>
</template>

<script>
import GeneralMixin from './../../mixin'

export default {
    mixins: [
        GeneralMixin,
    ],
    components: {

    },
    data() {
        return {
            pageID: 'notifications',
            pageTitle: 'Configuration',
            lists: {
                loaded: false,
                options: null,
            },
            form: {
                events: [],
                custom_admin_email_recipients: null,
            }
        }
    },
    computed: {
        optionsNotification() {
            return this.lists.options || {};
        },
        fallback() {
            return `${this.moduleCode}.${this.pageID}`;
        },
    },
    mounted() {
        this.loadItem(this.url.getConfig, false)
        .then( res => {
            if(!this.form.events) {
                this.form.events = [];
            }
            this.loadLists();
        });
    },
    methods: {
        loadLists: function() {
            if (!this.lists.loaded) {
                this.$http.get(this.url.getConfigLists)
                .then(res => {
                    let data = res.data;
                    Object.keys(data).forEach(key => {
                        if(Object.keys(this.lists).includes(key)){
                            this.lists[key] = data[key];
                        }
                    });
                    this.lists.loaded = true;
                })
                .catch(error => {
                    this.lists.loaded = false;
                    this.showHttpError(error);
                });
            }
        },
        onBeforeSaveItem(fallback) {
            if(this.canConfigEdit) {
                this.saveItem(fallback, [], {}, true);
            }
        },
    },
}
</script>

<style scoped lang="scss">
</style>
